import React from 'react';
import { formatPrice } from '../../utils/format';
import { ModeTag } from './ModeTag';
import { PayerTag } from './PayerTag';

/** Scelta prestazione: durata, modalità, prezzo. Selezionata = bordo brand 2px. */
export function ServiceOption({
  name,
  durationMin,
  mode,
  payer = 'privato',
  price,
  selected = false,
  onSelect,
  className = ''
}) {
  return (
    <button
      type="button"
      className={[
        'w-full min-h-touch rounded-vc border bg-vc-surface p-3 text-left',
        selected ? 'border-2 border-vc-primary' : 'border-vc-line',
        className
      ].join(' ')}
      aria-pressed={selected}
      onClick={onSelect}
    >
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-vc-md font-medium text-vc-ink">{name}</span>
        {mode && <ModeTag mode={mode} />}
        <PayerTag payer={payer} />
      </div>
      <div className="mt-1 flex flex-wrap gap-3 text-vc-sm text-vc-ink-2">
        {durationMin != null && <span>{durationMin} min</span>}
        {price != null && <span className="font-medium text-vc-ink">{formatPrice(price)}</span>}
      </div>
    </button>
  );
}
